/**
 * `GoogleGeometry.location`'s `lat`/`lng` fields are typed as `number | (() => number)`
 * depending on whether the coordinate came from a plain object literal or a live
 * `google.maps.LatLng` instance. Narrowing via `typeof` lets TypeScript resolve either
 * shape to a plain `number`.
 */
export const resolveLatLngValue = (value: number | (() => number)): number =>
  typeof value === "function" ? value() : value;
